import React, { useState } from 'react';
import { useAuth } from '../../auth/AuthProvider';

// İlk girişte zorunlu şifre değiştirme ekranı. AppRoot, mustChangePassword=true
// iken normal route'lar yerine bunu render eder; değiştirene kadar başka sayfaya geçilemez.
const SifreDegistirZorunlu = () => {
  const { changePassword, logout } = useAuth();
  const [current, setCurrent] = useState('');
  const [yeni, setYeni] = useState('');
  const [tekrar, setTekrar] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (yeni.length < 8) { setError('Yeni şifre en az 8 karakter olmalı.'); return; }
    if (yeni !== tekrar) { setError('Yeni şifreler eşleşmiyor.'); return; }
    if (yeni === current) { setError('Yeni şifre mevcut şifreden farklı olmalı.'); return; }
    setBusy(true);
    const res = await changePassword(current, yeni);
    setBusy(false);
    if (!res.ok) setError(res.error || 'Şifre değiştirilemedi.');
  };

  const inputStyle = { display: 'block', width: '100%', padding: 10, marginBottom: 10, border: '1px solid #ddd', borderRadius: 6, boxSizing: 'border-box' };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f5f5f5' }}>
      <form onSubmit={submit} style={{ background: 'white', padding: 32, borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: 360 }}>
        <h2 style={{ marginTop: 0, fontSize: 20, color: '#333' }}>🔒 Şifre Değiştirme Zorunlu</h2>
        <p style={{ fontSize: 14, color: '#666' }}>Güvenliğiniz için ilk girişte şifrenizi değiştirmeniz gerekiyor.</p>
        {error && <div style={{ background: '#fdecea', color: '#b71c1c', padding: '8px 12px', borderRadius: 6, fontSize: 13, marginBottom: 12 }}>{error}</div>}
        <input type="password" placeholder="Mevcut şifre" value={current} onChange={e => setCurrent(e.target.value)} style={inputStyle} />
        <input type="password" placeholder="Yeni şifre (en az 8 karakter)" value={yeni} onChange={e => setYeni(e.target.value)} style={inputStyle} />
        <input type="password" placeholder="Yeni şifre (tekrar)" value={tekrar} onChange={e => setTekrar(e.target.value)} style={{ ...inputStyle, marginBottom: 16 }} />
        <button type="submit" disabled={busy} style={{ width: '100%', padding: 12, background: busy ? '#999' : '#2e7d32', color: 'white', border: 'none', borderRadius: 6, cursor: busy ? 'default' : 'pointer', fontWeight: 'bold', fontSize: 15 }}>
          {busy ? 'Değiştiriliyor...' : 'Şifreyi Değiştir'}
        </button>
        <button type="button" onClick={logout} style={{ width: '100%', padding: 10, marginTop: 10, background: 'transparent', color: '#666', border: 'none', cursor: 'pointer', fontSize: 13 }}>
          Çıkış yap
        </button>
      </form>
    </div>
  );
};

export default SifreDegistirZorunlu;
